import { WorkOrderRecordType } from '@xbcb/shared-types';
import { isHtsReasonabilityEnabled } from 'featureFlags';

// Shared gate for the HTS reasonability feature. Reasonability is limited to US
// Consumption Entries, and only when the HTS reasonability feature is on. Used
// by both the Commercial Invoice product table's Reasonability column and the
// line-item Reasonability card.
export const isReasonabilityApplicable = (
  workOrderType?: WorkOrderRecordType,
): boolean =>
  isHtsReasonabilityEnabled &&
  workOrderType === WorkOrderRecordType.US_CONSUMPTION_ENTRY;
